<div class="receipt-transaction-summary" *ngIf="filteredTransactionData">
  <div id="receipt-transaction-card" *ngFor="let item of filteredTransactionData | keyvalue : unsortComparator">
    <div class="receipt-transaction-item">
      <span class="bolded"> {{ item.key }} </span>
      <span> {{ item.value }} </span>
    </div>
  </div>
</div>
